import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  HeadClothingManualExtensionPayload,
  StorekeeperIssuePayload
} from '../../../models/clothing.model';
import { ProfileClothingUnitItem, ProfileClothingViewItem } from '../../../models/profile-clothing.model';
import { ClothingHeadExtensionModalComponent } from '../../../modals/clothing-head-extension-modal.component';
import { ClothingIssueModalComponent } from '../../../modals/clothing-issue-modal.component';
import { BiometricsComponent } from './biometrics/biometrics.component';
import { GetClotheComponent } from './get-clothe/get-clothe.component';
import { AppConstants } from './app.constants';
import { UserProfile } from './view-user-profile.types';
import { PROFILE_EMPTY_TEXT } from './view-user-profile.constants';
import { ViewUserProfileFeedbackService } from './view-user-profile-feedback.service';

@Injectable()
export class ViewUserProfileClothingUi {
  constructor(
    private modalService: NgbModal,
    private feedback: ViewUserProfileFeedbackService
  ) {}

  openBiometrics(user: UserProfile, onSuccess: () => void): void {
    const modalRef = this.modalService.open(BiometricsComponent);
    modalRef.componentInstance.setId(user.id);
    if (user.parametersUser) {
      modalRef.componentInstance.setValue(user.parametersUser);
    }
    modalRef.result.then((result) => this.handleModalSuccess(result, onSuccess));
  }

  openClothes(user: UserProfile, onSuccess: () => void): void {
    const modalRef = this.modalService.open(GetClotheComponent);
    modalRef.componentInstance.setId(user.id);
    modalRef.result.then((result) => this.handleModalSuccess(result, onSuccess));
  }

  openIssue(
    item: ProfileClothingViewItem,
    employeeName: string,
    onSubmit: (payload: StorekeeperIssuePayload) => void
  ): void {
    const modalRef = this.modalService.open(ClothingIssueModalComponent);
    modalRef.componentInstance.setValues(item.name, item.issueQuantity, employeeName);
    modalRef.result.then(onSubmit, () => null);
  }

  openHeadExtension(
    item: ProfileClothingViewItem,
    unit: ProfileClothingUnitItem,
    onSubmit: (payload: HeadClothingManualExtensionPayload) => void
  ): void {
    const modalRef = this.modalService.open(ClothingHeadExtensionModalComponent);
    modalRef.componentInstance.setValues(item.name, unit ? unit.unitId : PROFILE_EMPTY_TEXT);
    modalRef.result.then(onSubmit, () => null);
  }

  success(messageKey: string): void {
    this.feedback.success(messageKey);
  }

  error(error: HttpErrorResponse, fallbackKey: string): void {
    this.feedback.clothingError(error, fallbackKey);
  }

  private handleModalSuccess(result: Object, onSuccess: () => void): void {
    if (result === AppConstants.MODAL_RESULT.OK && onSuccess) {
      onSuccess();
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-clothing.ui.ts